import React, { Component, Suspense } from 'react';
import { Card } from 'react-bootstrap'

class UserProfile extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { queues: [{ codingEvents: [] }] };
    }

    render() {
        return (
            <Card>
                <Card.Header className="d-flex align-items-center">
                    <div className="mr-auto" >UserProfile</div>
                    <div className="card-btn-group">
                    </div>
                </Card.Header>
                <Card.Body>
                    <div>UserProfile</div>
                </Card.Body>
            </Card>
        );
    }

}

export default UserProfile;